import React, { useState } from 'react';
import { Row, Col, Card, CardBody } from "reactstrap";
import ReactApexChart from 'react-apexcharts';

const MonthlyEarnings = ({ dashboardData }) => {
    const [options] = useState({
        colors: ['#ccc', '#7a6fbe', 'rgb(40, 187, 227)'],
        chart: {
            toolbar: {
                show: false,
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: 'smooth',
            width: 0.1,
        },
        grid: {
            borderColor: '#f8f8fa',
            row: {
                colors: ['transparent', 'transparent'],
                opacity: 0.5
            },
        },
        xaxis: {
            categories: ['2018', '2019', '2020', '2021', '2022', '2023', '2024'],
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            }
        },
        legend: {
            show: false
        },
    });

    const [series] = useState([
        {
            name: 'Series A',
            data: [0, 150, 60, 180, 90, 75, 30]
        },
        {
            name: 'Series B',
            data: [0, 45, 150, 36, 60, 240, 30]
        },
        {
            name: 'Series C',
            data: [0, 15, 195, 21, 360, 120, 30]
        }
    ]);

    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <h4 className="card-title mb-4">Student Join</h4>

                    <Row className="text-center mt-4">
                        <Col xs="4">
                            <h5 className="font-size-20"> {dashboardData?.studentCount === null || dashboardData?.studentCount === 0 ? "0" : dashboardData?.studentCount || "--"}</h5>
                            <p className="text-muted">Purchase Course</p>
                        </Col>
                        <Col xs="4">
                            <h5 className="font-size-20">--</h5>
                            <p className="text-muted">Complete Course</p>
                        </Col>
                        <Col xs="4">
                            <h5 className="font-size-20">--</h5>
                            <p className="text-muted">Pending Course</p>
                        </Col>
                    </Row>

                    <div id="morris-area-example" className="morris-charts morris-charts-height" dir="ltr">
                        <ReactApexChart options={options} series={series} type="area" height="300" />
                    </div>
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default MonthlyEarnings;
